import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { OutBooksTitle } from "./GlobalMessage";

/*
 * Inside the main app layout the footer is drawn ONCE by <FooterSlot>, as the
 * last child of .main-content, so it always sits at the bottom of the page
 * (layout.css: .main-content is a flex column and .footer has margin-top:auto).
 *
 * Pages keep rendering <Footer /> as before. Inside the layout that call only
 * tells the slot "this page has a footer" and renders nothing in place, so the
 * footer no longer floats in the middle of short pages. Outside the layout
 * (e.g. Getting Started) <Footer /> renders itself exactly as it used to.
 */
const FooterSlotContext = createContext(null);

const FooterBar = ({ inLayout }) => (
  <footer
    className={`footer text-center py-2 ${inLayout ? "app-footer" : "bg-light w-100"}`}
    style={inLayout ? undefined : { position: "fixed", bottom: 0 }}
  >
    © {new Date().getFullYear()} {OutBooksTitle}
  </footer>
);

export function FooterSlot({ children }) {
  const [footerRequests, setFooterRequests] = useState(0);

  const slot = useMemo(
    () => ({
      add: () => setFooterRequests((count) => count + 1),
      remove: () => setFooterRequests((count) => Math.max(0, count - 1)),
    }),
    [],
  );

  return (
    <FooterSlotContext.Provider value={slot}>
      {children}
      {footerRequests > 0 && <FooterBar inLayout />}
    </FooterSlotContext.Provider>
  );
}

function Footer() {
  const slot = useContext(FooterSlotContext);

  useEffect(() => {
    if (!slot) return undefined;
    slot.add();
    return slot.remove;
  }, [slot]);

  if (slot) return null;

  return (
    <div>
      <FooterBar />
    </div>
  );
}

export default Footer;
